import localforage from 'localforage';

/**
 * Wrapper tipado sobre localforage y localStorage
 * Punto de entrada único para el almacenamiento del navegador
 */

/**
 * Métodos asíncronos basados en localforage
 */
const getItem = <T>(key: string): Promise<T | null> => localforage.getItem<T>(key);

const setItem = <T>(key: string, value: T): Promise<T> => localforage.setItem<T>(key, value);

const removeItem = (key: string): Promise<void> => localforage.removeItem(key);

const clear = (): Promise<void> => localforage.clear();

/**
 * Métodos síncronos basados en localStorage
 */
const getLocalItem = <T>(key: string): T | null => {
  const raw = window.localStorage.getItem(key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    // valor legado guardado como string plano, no serializado con JSON.stringify
    return raw as unknown as T;
  }
};

const setLocalItem = <T>(key: string, value: T): void => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

const removeLocalItem = (key: string): void => window.localStorage.removeItem(key);

const clearLocal = (): void => window.localStorage.clear();

const storageService = { getItem, setItem, removeItem, clear, getLocalItem, setLocalItem, removeLocalItem, clearLocal };

export default storageService;
